import {
  IReqProps,
  useLazyGroupAccountsByPageQuery,
  useAppSelector,
  useLazyGetInstByAccountQuery,
  useLazyGetAssetByAccountQuery,
  useAppDispatch,
  useLazyGetInstanceExtraInfoQuery
} from '@monorepo/shared';
import { selectGroups } from '@monorepo/shared/store/groupSlice';
import { useEffect, useState } from 'react';
import { Pagination } from 'rsuite';
interface IProps {
  currentGroup: Record<string, any>;
  setRefreshHandler?: React.Dispatch<
    React.SetStateAction<React.MouseEventHandler<HTMLElement> | undefined>
  >;
  setTableData: any;
  setLoading: any;
  setEmptyMessage: any;
  groupSearchKeyValue: Record<string, any>;
  sortColumn: string;
  setSortColumn: any;
  sortType: string;
}
export const OrgPagination = ({
  currentGroup,
  setRefreshHandler,
  setTableData,
  setLoading,
  setEmptyMessage,
  groupSearchKeyValue,
  setSortColumn,
  sortColumn,
  sortType
}: IProps) => {
  // const limits = [20, 50, 100];
  const limits = [10, 20, 50, 100];
  const dispatch = useAppDispatch();
  const [limit, setLimit] = useState<number>(limits[0]);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [accounts, setAccounts] = useState<Record<string, any>[]>([]);
  const [clickCountNumber, setClickCountNumber] = useState<number>(0);
  const groups = useAppSelector(selectGroups);
  const initReq = {
    groupId: currentGroup.id,
    regionObj: currentGroup.regionObj,
    accountIds: [],
    page: page,
    pageSize: limit,
    searchObj: groupSearchKeyValue.key
      ? {
          key: groupSearchKeyValue.key,
          value: groupSearchKeyValue.value.trim()
        }
      : undefined,
    sortColumn: sortColumn,
    sortType: sortType
  };
  const validSortCols = ['account_id', 'account_company', 'master_user_name'];
  let requestArg: IReqProps = { ...initReq };
  // const getGroupAccounts = useGroupAccountsByPageQuery(requestArg, {
  //   skip: !requestArg.regionObj?.token,
  //   refetchOnMountOrArgChange: true
  // });
  const [getGroupAccounts] = useLazyGroupAccountsByPageQuery();

  const handleChangeLimit = async (pageSize: number) => {
    setPage(1);
    setLimit(pageSize);
    const req = {
      ...initReq,
      page: 1,
      pageSize: pageSize
    };
    requestArg = req;
    reloadData(requestArg);
  };
  const handleChangePage = async (page: number) => {
    setPage(page);
    const req = {
      ...initReq,
      page: page
    };
    requestArg = req;
    reloadData(requestArg);
  };

  const reloadData = async (req: IReqProps) => {
    setLoading(true);
    const { data, isLoading, isError, error } = await getGroupAccounts(req);
    if (setEmptyMessage) {
      if (isError) {
        const res = error as Record<any, any>;
        setEmptyMessage(res?.data?.detail);
      } else if (data?.data?.count === 0) {
        setEmptyMessage('No data found');
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    setPage(1);
    setTotalPage(1);
    const req = {
      ...requestArg,
      groupId: currentGroup.id,
      regionObj: currentGroup.regionObj,
      page: 1
    };
    requestArg = req;
    if (setRefreshHandler) {
      setRefreshHandler(() => reloadData);
    }
    if (!validSortCols.includes(sortColumn)) {
      setSortColumn('account_id');
    }
  }, [currentGroup.id]);

  useEffect(() => {
    setPage(1);
    const req = {
      ...initReq,
      groupId: currentGroup.id,
      page: 1,
      pageSize: limit,
      searchObj: groupSearchKeyValue.key
        ? {
            key: groupSearchKeyValue.key,
            value: groupSearchKeyValue.value.trim()
          }
        : undefined,
      sortColumn: sortColumn,
      sortType: sortType
    };
    requestArg = req;
    if (clickCountNumber && groupSearchKeyValue.clickBtnNum) {
      reloadData(requestArg);
    }
  }, [clickCountNumber, sortColumn, sortType]);

  useEffect(() => {
    setClickCountNumber(groupSearchKeyValue.clickBtnNum);
  }, [groupSearchKeyValue.clickBtnNum]);

  useEffect(() => {
    const groupAccounts = groups[currentGroup?.id].accounts;
    if (groupAccounts) {
      const groupAccountArr: Record<string, any>[] =
        Object.values(groupAccounts);
      setAccounts(groupAccountArr);
      const accounts = groupAccountArr
        .sort((a, b) => a.order - b.order)
        .map((obj: Record<string, any>, index: number) => {
          return {
            ...obj,
            ou: obj?.account_company,
            regionName: obj?.region?.name || obj?.region?.alias,
            hasAccount: true,
            level: 0,
            isLeaf: true,
            value: `${index}-${obj?.account_id}`,
            children: [
              {
                ...obj,
                isAccount: true,
                level: 1
              }
            ]
          };
        });
      setTableData(accounts);
    }
  }, [groups]);

  const [getInstance] = useLazyGetInstByAccountQuery();
  const [getAsset] = useLazyGetAssetByAccountQuery();
  const [getInstanceExtra] = useLazyGetInstanceExtraInfoQuery();
  useEffect(() => {
    Object.values(accounts).forEach((account) => {
      if (account.region?.token) {
        getInstance({
          account: account
        });
        getAsset({
          account: account
        });
        getInstanceExtra({ account: account });
      }
    });
  }, [accounts]);

  return (
    <div style={{ padding: 20 }}>
      <Pagination
        prev
        next
        first
        last
        ellipsis
        boundaryLinks
        maxButtons={5}
        size="xs"
        layout={['total', '-', 'limit', '|', 'pager', 'skip']}
        total={groups[currentGroup.id].count}
        limitOptions={limits}
        limit={limit}
        activePage={page}
        onChangePage={handleChangePage}
        onChangeLimit={handleChangeLimit}
      />
    </div>
  );
};
